import {makeAutoObservable, runInAction} from "mobx";
import CategoryService from "../Services/CategoryService";
import {toJS} from "mobx";

class CategoryStore {
    isInitialized = false; // False until everything is loaded
    categoryTree = [];
    categoryList = [];
    categorySearchList = [];

    constructor() {
        makeAutoObservable(this);
        this.init();
    }

    async init() {
        await this.fetchCategories();

        runInAction(() => {
            this.isInitialized = true;
        });
    }

    async fetchCategories() {
        // todo combine these into one call
        const categoryTree = await CategoryService.fetchCategoryTree();
        const categoryList = await CategoryService.fetchCategoryList();
        const categorySearchList = await CategoryService.fetchCategorySearchList();

        runInAction(() => {
            this.categoryTree = categoryTree;
            this.categoryList = categoryList;
            this.categorySearchList = categorySearchList;
        });
    }
}

export const categoryStore = new CategoryStore();
